import React from 'react'
import { IoClose, IoDownload } from 'react-icons/io5'
import { usePWAInstall } from '../hooks/usePWAInstall'

export function PWAInstallBanner() {
  const { showBanner, promptInstall, dismiss } = usePWAInstall()

  if (!showBanner) return null

  const handleInstall = async () => {
    await promptInstall()
  }

  return (
    <div className="pwa-install-banner">
      <div className="pwa-banner-content">
        <div className="pwa-banner-icon">
          <IoDownload size={20} />
        </div>
        <div className="pwa-banner-text">
          <span className="pwa-banner-title">Install StatScout</span>
          <span className="pwa-banner-subtitle">Add to home screen for the best experience</span>
        </div>
      </div>
      <div className="pwa-banner-actions">
        <button className="pwa-install-btn" onClick={handleInstall}>
          Install
        </button>
        <button className="pwa-dismiss-btn" onClick={dismiss} aria-label="Dismiss">
          <IoClose size={18} />
        </button>
      </div>
    </div>
  )
}
